__turbopack_context__.v({
  "dark": "BOsvYW_dark",
  "dimmer": "BOsvYW_dimmer",
});
